import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FullScreenImageComponent } from "./image-gallery/full-screen-image/full-screen-image.component";
import { PhoenixImageComponentComponent } from "./image-gallery/image-component/phoenix-image-component.component";
import { FullscreenInfoComponent } from "./image-gallery/full-screen-image/fullscreen-info/fullscreen-info.component";
import { UploadSelectionFileDialogComponent } from "./upload-selection-file-dialog/upload-selection-file-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PropertyReportComponent } from "./property-report/property-report.component";
import { CustomDialogComponent } from "./custom-dialog/custom-dialog.component";
import { PointInfoPopupComponent } from "./point-info-popup/point-info-popup.component";
import { GroundElevationPopupComponent } from "./ground-elevation-popup/ground-elevation-popup.component";
import { VectorLayerPopupComponent } from "./vector-layer-popup/vector-layer-popup.component";
import { ConfirmDownloadDialogComponent } from "./confirm-download/confirm-download-dialog";
import { PhoenixWmsLayerResultsDialogComponent } from "./wms-layer-results-dialog/phoenix-wms-layer-results-dialog.component";
import { PhoenixVectorTileLayerResultsDialogComponent } from "./vector-tile-layer-results-dialog/phoenix-vector-tile-layer-results-dialog.component";
import { PhoenixWmtsLayerResultsDialogComponent } from "./wmts-layer-results-dialog/phoenix-wmts-layer-results-dialog.component";
import { PhoenixWfsLayerResultsDialogComponent } from "./wfs-layer-results-dialog/phoenix-wfs-layer-results-dialog.component";
import { PhoenixArcGISLayerResultsDialogComponent } from "./arcgis-layer-results-dialog/phoenix-arcgis-layer-results-dialog.component";
import { PhoenixXyzLayerResultsDialogComponent } from "./xyz-layer-result-dialog/phoenix-xyz-layer-results-dialog.component";
import { PhoenixArcGISFeatureLayerComponent } from "./arcgis-feature-layer/phoenix-arcgis-feature-layer.component";
import { PhoenixVectorTileLayerComponent } from "./vector-tile-layer/phoenix-vector-tile-layer.component";
import { PhoenixXyzLayerComponent } from "./xyz-layer/phoenix-xyz-layer.component";
import { PhoenixUploadLayerDialogComponent } from "./upload-layer-dialog/phoenix-upload-layer-dialog.component";
import { EditLayerDialogComponent } from "./edit-layer-dialog/edit-layer-dialog.component";
import { PhoenixMultiExportGeotiffDialog } from "./multi-export-geotiff-dialog/phoenix-multi-export-geotiff-dialog";
import { DamageAssessmentDialogComponent } from "./damage-assessment-dialog/damage-assessment-dialog.component";
import { PropertyInformationDialogComponent } from "./property-information-dialog/property-information-dialog.component";
import { DialogGalleryComponent } from "./image-gallery/dialog-gallery/dialog-gallery.component";
import { DockGalleryComponent } from "./image-gallery/dock-gallery/dock-gallery.component";
import { PhoenixWfsLayerComponent } from "./wfs-layer/phoenix-wfs-layer.component";
import { CustomGalleryImageComponent } from "./image-gallery/custom-gallery-image/custom-gallery-image.component";
import { PhoenixWmtsLayerComponent } from "./wmts-layer/phoenix-wmts-layer.component";
import { PhoenixWmsLayerComponent } from "./wms-layer/phoenix-wms-layer.component";
import { MultipleCollectionsWarningComponent } from "./multiple-collections-warning/multiple-collections-warning.component";
import { PhoenixExportFeaturesComponent } from "./export-layer/phoenix-export-features.component";
import { SharedComponentsModule } from "../shared-components/shared-components.module";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

import { MatTooltipModule } from "@angular/material/tooltip";

import { MatDividerModule } from "@angular/material/divider";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatSliderModule } from "@angular/material/slider";
import { MatExpansionModule } from "@angular/material/expansion";
import { AddUserDataDialogComponent } from "./add-user-data-dialog/add-user-data-dialog.component";
import { AddLayerItemComponent } from "./add-user-data-dialog/add-layer-item/add-layer-item.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatListModule } from "@angular/material/list";
import { ColorPickerDirective } from "ngx-color-picker";
import { OverlayModule } from "@angular/cdk/overlay";
import { ColorSwatchPickerComponent } from "../shared-components/color-swatch-picker/color-swatch-picker.component";

@NgModule({
  declarations: [
    DialogGalleryComponent,
    CustomDialogComponent,
    PointInfoPopupComponent,
    GroundElevationPopupComponent,
    VectorLayerPopupComponent,
    ConfirmDownloadDialogComponent,
    PhoenixWmsLayerResultsDialogComponent,
    PhoenixVectorTileLayerResultsDialogComponent,
    PhoenixWmtsLayerResultsDialogComponent,
    PhoenixWfsLayerResultsDialogComponent,
    PhoenixArcGISLayerResultsDialogComponent,
    PhoenixXyzLayerResultsDialogComponent,
    PhoenixArcGISFeatureLayerComponent,
    PhoenixVectorTileLayerComponent,
    PhoenixXyzLayerComponent,
    PhoenixUploadLayerDialogComponent,
    GroundElevationPopupComponent,
    VectorLayerPopupComponent,
    ConfirmDownloadDialogComponent,
    EditLayerDialogComponent,
    PhoenixMultiExportGeotiffDialog,
    DamageAssessmentDialogComponent,
    PropertyInformationDialogComponent,
    DialogGalleryComponent,
    DockGalleryComponent,
    PhoenixWfsLayerComponent,
    CustomGalleryImageComponent,
    PhoenixWmtsLayerComponent,
    PhoenixWmsLayerComponent,
    PhoenixWfsLayerComponent,
    CustomDialogComponent,
    MultipleCollectionsWarningComponent,
    PhoenixExportFeaturesComponent,
    FullScreenImageComponent,
    PhoenixImageComponentComponent,
    FullscreenInfoComponent,
    PropertyReportComponent,
    UploadSelectionFileDialogComponent,
    AddUserDataDialogComponent,
    AddLayerItemComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    MatIconModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    MatButtonModule,
    MatInputModule,
    MatSliderModule,
    MatListModule,
    ColorPickerDirective,
    OverlayModule,
    ColorSwatchPickerComponent,
  ],
  exports: [
    DialogGalleryComponent,
    CustomDialogComponent,
    PointInfoPopupComponent,
    GroundElevationPopupComponent,
    VectorLayerPopupComponent,
    ConfirmDownloadDialogComponent,
    PhoenixWmsLayerResultsDialogComponent,
    PhoenixVectorTileLayerResultsDialogComponent,
    PhoenixWmtsLayerResultsDialogComponent,
    PhoenixWfsLayerResultsDialogComponent,
    PhoenixArcGISLayerResultsDialogComponent,
    PhoenixXyzLayerResultsDialogComponent,
    PhoenixArcGISFeatureLayerComponent,
    PhoenixVectorTileLayerComponent,
    PhoenixXyzLayerComponent,
    PhoenixUploadLayerDialogComponent,
    GroundElevationPopupComponent,
    VectorLayerPopupComponent,
    ConfirmDownloadDialogComponent,
    EditLayerDialogComponent,
    PhoenixMultiExportGeotiffDialog,
    DamageAssessmentDialogComponent,
    PropertyInformationDialogComponent,
    DialogGalleryComponent,
    DockGalleryComponent,
    PhoenixWfsLayerComponent,
    CustomGalleryImageComponent,
    FullScreenImageComponent,
    AddUserDataDialogComponent,
  ],
})
export class DialogComponentsModule {}
